import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright (c) 2021 lingdocs.com
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { createElement } from "react";
import classNames from "classnames";

var caretRight = _jsx("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  className: "bi bi-caret-right-fill",
  viewBox: "0 0 16 16"
}, {
  children: _jsx("path", {
    d: "M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
  }, void 0)
}), void 0);

var caretDown = _jsx("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  className: "bi bi-caret-down-fill",
  viewBox: "0 0 16 16"
}, {
  children: _jsx("path", {
    d: "M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
  }, void 0)
}), void 0);

var defaultLevel = 4;
var indentAfterLevel = 5;

function Hider(props) {
  var hLev = Math.min(props.hLevel ? props.hLevel : defaultLevel, 6);
  var extraMargin = props.hLevel && props.hLevel > indentAfterLevel ? "ml-".concat(props.hLevel - indentAfterLevel + 1) : "";
  return _jsxs("div", Object.assign({
    className: "mb-3"
  }, {
    children: [createElement("h".concat(hLev), {
      onClick: props.handleChange,
      className: classNames("clickable", extraMargin)
    }, _jsxs(_Fragment, {
      children: [props.showing ? caretDown : caretRight, " ", props.aspect ? _jsx("i", {
        className: "fas fa-".concat(props.aspect === "imperfective" ? "video" : "camera", " mr-2")
      }, void 0) : "", props.label]
    }, void 0)), props.showing && props.children]
  }), void 0);
}

export default Hider;